import { Typography } from '@mui/material';
import { Layout } from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { ContactSCD } from './Contact';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { IndustriesWePower } from './IndustriesWePower';
import { smartContractDevelopmentSeo } from './smartContractDevelopmentPage.seo';
import type { SmartContractDevelopmentPageProps } from './smartContractDevelopmentPage.types';
import { SmartContractDevelopmentProcess } from './SmartContractDevelopmentProcess';
import { SmartContractDevelopmentServices } from './SmartContractDevelopmentServices/SmartContractDevelopmentServices';
import { StyledContainer, StyledTypographySmall } from './styles';
import { WhyRF } from './WhyRF';
import { WhyUseSmartContracts } from './WhyUseSmartContracts';
import { OurWork } from './OurWork';

export const SmartContractDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: SmartContractDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...smartContractDevelopmentSeo} />
      <Hero />
      <SmartContractDevelopmentServices />
      <WhyRF />
      <SmartContractDevelopmentProcess />
      <IndustriesWePower />
      <WhyUseSmartContracts />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <ContactSCD />
      <StyledContainer>
        <StyledTypographySmall>
          <Typography component="span" sx={{ fontWeight: '600' }}>
            Rumble Fish
          </Typography>
          <Typography component="span">
            &nbsp;- the best smart contract development team
          </Typography>
        </StyledTypographySmall>
      </StyledContainer>
    </Layout>
  );
};
